import { NestedRoutes } from "../../app/routes.types";
import { AgreementConversionsFunnel } from "./AgreementConversionsFunnel";
import { MetricsAndReports } from "./MetricsAndReports";

export const metricsRoutes: NestedRoutes = {
  name: "Metrics & Reporting",
  path: "metrics",
  component: MetricsAndReports,
  children: [
    {
      name: "Agreement Conversions Funnel",
      path: "agreementConversionsFunnel",
      component: AgreementConversionsFunnel,
    },
  ],
};
